import React, {useState} from 'react'
import styled from 'styled-components'
import Card, {CardProps} from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import {CardActionArea, CardHeader, Collapse} from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import FocusAtom from '../focus/focus.atom'
import TypographyAtom from '../typography/typography.atom'
import card_delivery_detailStyles from './card_delivery_detail.styles'
import ProgressBarAtom from '../../to_forms/progressbar/progressbar.atom'
import ProductDeliveryActionsAtom from '../delivery_actions/delivery_actions.atom'
import StackAtom from '../../to_layout/stack/stack.atom'
import ProductSofa from '../../../assets/images/productSofa.jpg'
import ProductListItemAtom from '../product_list/productlist_item.atom'
import BoxImage from '../../../assets/images/box.jpg'
import ButtonAtom from '../../to_forms/button/button.atom'

interface ApDeliveryDetailDesktopProps extends CardProps {
  ap_visit_val: string
  ap_arrival_date: string
  ap_arrival_time: string
  ap_progress_status_arr: string[]
  ap_delivery_details: string
  ap_progress_step: number
}

const apAtomName = {ap_atom_name: 'cardDeliveryDetailAtom'}

/* DEFAULT MODULE 
================================================= */
const CardDeliveryDetailAtom = styled((props: ApDeliveryDetailDesktopProps) => {
  const {
    ap_visit_val,
    ap_arrival_date,
    ap_arrival_time,
    ap_delivery_details,
    ap_progress_status_arr,
    ap_progress_step,
  } = props
  const [expanded, setExpanded] = useState<boolean>(false)
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <Card {...apAtomName} {...props} variant="outlined">
      <CardHeader
        action={
          <StackAtom ap_type="column" className="card-delivery-details-actions">
            <CardActionArea disableRipple onClick={handleExpandClick}>
              <TypographyAtom ahd_type="navLink" justifyContent="flex-end">
                View Details
                {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </TypographyAtom>
            </CardActionArea>
            {!expanded && (
              <ButtonAtom ap_type="primary">Book Your Delivery Date</ButtonAtom>
            )}
          </StackAtom>
        }
        title={
          <TypographyAtom ap_type="title" justifyContent="flex-start">
            Visit: <FocusAtom>{ap_visit_val}</FocusAtom>
          </TypographyAtom>
        }
        subheader={
          <>
            <TypographyAtom ap_type="subtitle">
              {new Date(ap_arrival_date)
                .toLocaleDateString(navigator.language, {
                  weekday: 'long',
                  month: 'long',
                  day: 'numeric',
                })
                .replace(',', '')}
            </TypographyAtom>
            <TypographyAtom ap_type="title">
              Expected Arrival: {ap_arrival_date}
            </TypographyAtom>
            <TypographyAtom ahd_type="regText">
              {ap_arrival_time}
            </TypographyAtom>
          </>
        }
      />
      <CardContent>
        <ProgressBarAtom
          ap_progress_status_arr={ap_progress_status_arr}
          ap_progress_step={ap_progress_step}
        />
      </CardContent>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <StackAtom ap_type="row">
            <div>
              <StackAtom ap_type="column">
                <ProductListItemAtom
                  ap_type="productImage"
                  ap_product_image={ProductSofa}
                />
                <ProductListItemAtom ap_type="packageIcon" />
                <ProductListItemAtom
                  ap_type="productImage"
                  ap_product_image={BoxImage}
                />
              </StackAtom>
            </div>
            <div>
              <ProductDeliveryActionsAtom
                ap_delivery_details={ap_delivery_details}
              />
            </div>
          </StackAtom>
        </CardContent>
      </Collapse>
    </Card>
  )
})`
  ${card_delivery_detailStyles};
`
export default CardDeliveryDetailAtom
